import React from 'react';
import { GridTable } from '@components/common/grid';
import { formatWithDefault, formatCurrency } from '@common/utils';

const GridTableRpuAndAnnuityBegin = ({
  id = 'grid-policy-change-rpu-annuity',
  title,
  data,
  isCurrencyUsd,
}) => (
  <GridTable
    id={id}
    title={title}
    sideTitle={isCurrencyUsd ? '(단위: 달러)' : '(단위: 원)'}
    options={{
      data,
      colNames: [
        '감액완납 시 보험금액',
        '감액완납 시 변경차액',
        '단축 시 만기보험금액',
      ],
      colModel: [
        {
          name: 'reduPdupBnf',
          index: 'reduPdupBnf',
          formatter: formatWithDefault(value =>
            formatCurrency(value, isCurrencyUsd),
          ),
        },
        {
          name: 'reduPdupChgDfnnt',
          index: 'reduPdupChgDfnnt',
          formatter: formatWithDefault(value =>
            formatCurrency(value, isCurrencyUsd),
          ),
        },
        {
          name: 'shtnAnutyBgnExpirBnf',
          index: 'shtnAnutyBgnExpirBnf',
          formatter: formatWithDefault(value =>
            formatCurrency(value, isCurrencyUsd),
          ),
        },
      ],
    }}
  />
);

export default GridTableRpuAndAnnuityBegin;
